<template>
  <div class="user-list-info-box">
    <div class="main-container">
      <h2 class="">{{$t('page_title')}}</h2>
      <p v-if="lodg_data.status == 1 || lodg_data.status == 3" class="top-status-messege1" :class="{ important_color: check_accept }">{{ $t('status_messege1') }}</p>

      <div class="info-box">
        <div class="lodg-info">
          <p class="info-title">{{$t('room_no')}}</p>
          <p class="info-item">{{lodg_data.listing_name}}</p>
          <p class="info-title">{{$t('name_of_representative')}}</p>
          <p class="info-item">{{lodg_data.name}}</p>
          <p class="info-title">{{$t('check_in_date')}}</p>
          <p class="info-item">{{lodg_data.check_in}}</p>
          <p class="info-title">{{$t('check_out_date')}}</p>
          <p class="info-item">{{lodg_data.check_out}}</p>
          <p class="info-title">{{$t('email_of_representative')}}</p>
          <p class="info-item">{{lodg_data.email}}</p>
          <p class="info-title">{{$t('number_of_people')}}</p>
          <p class="info-item">{{lodg_data.customer_num}}</p>
          <p class="info-title">{{$t('status')}}</p>
          <p class="info-item">{{$t(status_text)}}</p>
          <div class="info-btn-box">
            <input type="button" class="message-btn" :value="$t('check_in_info')" @click="message_pop('m_5')">
            <input type="button" class="message-btn" :value="$t('check_in_qr')" @click="get_qr(list)">
            <input type="button" class="message-btn message-btn-s" :value="$t('recommend_info')" @click="message_pop('m_6')">
          </div>
        </div>

        <div class="list-box">
          <div class="remand-box" v-if="remand_data">
            <h2>{{$t('reason')}}</h2>
            <div class="">
              {{remand_data.remand_text}}
            </div>
            <p class="remand-date">{{$t('r_date')}}：{{remand_data.date}}</p>
          </div>

          <div class="list-header-box">
            <div class="flex">
              <p class="list-item1"></p>
              <p class="list-item2">{{$t('name')}}</p>
            </div>
          </div>

          <div class="list-contents-box">
            <div class="flex" v-for="(list, index) in lists" :key="index">
              <p class="list-item1">
                <span>{{index + 1}}{{$t('person')}}<span v-if="index == 0">{{$t('representative')}}</span></span>
                <!-- <input type="button" class="qr-btn" v-if="list.id" :value="$t('checkinQR')" @click="get_qr(list)"> -->
              </p>
              <p class="list-item2"><a class="" @click="list_info(list, index)">{{(list.name) ? list.name : $t('unregistered')}}</a></p>
            </div>
          </div>
          <!-- <p v-if="lodg_data.status == 1 || lodg_data.status == 3">{{$t('status_messege1')}}</p> -->
          <p v-if="lodg_data.status == 1 || lodg_data.status == 3" class="bottom-status-messege1" :class="{ important_color: check_accept }">{{$t('status_messege1')}}</p>
        </div>
      </div>

      <!-- <div class="btn-box" v-if="lodg_data.status == 1 || lodg_data.status == 3" >
        <input v-if="lodg_data.status == 1" type="button" class="new-add" @click="accept" :value="$t('send')" />
        <input v-if="lodg_data.status == 3" type="button" class="new-add" @click="accept" :value="$t('resend')" />
      </div> -->
      <div class="btn-box" v-if="lodg_data.status == 1 || lodg_data.status == 3">
        <input v-if="lodg_data.status == 1" type="button" class="new-add" :class="{ important_background: check_accept }" @click="accept" :value="$t('send')" />
        <input v-if="lodg_data.status == 3" type="button" class="new-add" :class="{ important_background: check_accept }" @click="accept" :value="$t('resend')" />
      </div>

    </div>
  </div>
</template>

<script>
import CustomerEdit from '@/views/popup/CustomerEdit';
import CustomerInfo from '@/views/popup/CustomerInfo';
import MailMessage from '@/views/popup/MailMessage';
import GetQr from '@/views/popup/GetQr';
export default {
  name: 'UserListInfo',
  language: {
    'ja': {
      'page_title': '宿泊情報詳細',
      'name_of_representative': '代表者名',
      'email_of_representative': '代表者 email',
      'check_in_date': 'チェックイン',
      'check_out_date': 'チェックアウト',
      'number_of_people': '人数',
      'room_no': '部屋名',
      'person': '人目',
      'name': '宿泊者名',
      'unregistered': '未登録',
      'send': '送信',
      'resend': '再送信',
      'send_err': '全ての宿泊者情報を登録してください。',
      'register_ok': '宿泊者情報を送信しました。',
      'status': '宿泊情報ステータス',
      'unsend': '未送信',
      'sended': '承認待ち',
      'accepted': '承認済み',
      'remand': '差戻し',
      'send_messege': '送信しますか？',
      'status_messege1': '※ 宿泊者情報を全て登録後、下部の送信ボタンで送信してください。',
      'reason': '差戻し理由',
      'r_date': '差戻し日',
      'representative': '(代表者)',
      'check_in_info': 'チェックイン方法',
      'check_in_qr': 'チェックインQR読み取り',
      'recommend_info': 'おすすめ情報',
      'checkinQR': 'チェックイン/アウト用QR',
    },
    'en': {
      'page_title': 'Accommodation details',
      'name_of_representative': 'name of representative',
      'email_of_representative': 'email of representative',
      'check_in_date': 'Check in',
      'check_out_date': 'Check out',
      'number_of_people': 'Number of people',
      'room_no': 'Room Name',
      'person': ' person',
      'name': 'Guest name',
      'unregistered': 'Unregistered',
      'send': 'Send',
      'resend': 'Resend',
      'send_err': 'Please register all guest information.',
      'register_ok': 'Guest information has been sent.',
      'status': 'Accommodation Status',
      'unsend': 'Unsent',
      'sended': 'Approval pending',
      'accepted': 'Approved',
      'remand': 'Remand',
      'send_messege': 'Do you want to send?',
      'status_messege1': '※ After registering all the guest information, please send with the send button at the bottom.',
      'reason': 'Reason for remand',
      'r_date': 'Remand date',
      'representative': '(representative)',
      'check_in_info': 'How to check in',
      'check_in_qr': 'Check-in QR reading',
      'recommend_info': 'Recommended information',
      'checkinQR': 'QR for check in/out',
    }
  },
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      lodg_data: {},
      lists: [],
      remand_data: null,
      owner: {},
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    status_text () {
      if (this.lodg_data.status === 1) {
        return 'unsend';
      } else if (this.lodg_data.status === 2) {
        return 'sended';
      } else if (this.lodg_data.status === 3) {
        return 'remand';
      } else {
        return 'accepted';
      }
    },
    check_accept () {
      const num = this.lists.length;
      for (let i = 0; i < num; i++) {
        if (this.$lib._emptyChk(this.lists[i].name) === false) {
          return false;
        }
      }
      return true;
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.data_get();
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get () {
      let ld = new this.$loader(this);
      ld._data_set({});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('user_list_info_get.php');
    },
    data_get_cb (res) {
      this.lodg_data = res.data.lodg_data;
      this.lists = res.data.customer_list;
      this.remand_data = res.data.remand;
      this.owner = res.data.owner;
    },
    accept () {
      const num = this.lists.length;
      for (let i = 0; i < num; i++) {
        if (this.$lib._emptyChk(this.lists[i].name) === false) {
          this.$alert('alert', this.$t('send_err'));
          return;
        }
      }

      this.$alert('alert', this.$t('send_messege'), this.accept_cb);
    },
    accept_cb () {
      let ld = new this.$loader(this);
      ld._data_set({});
      ld._post_cb_f = this.register_cb;
      ld._load_start('register.php');
    },
    register_cb () {
      this.$alert('info', this.$t('register_ok'));
      this.lodg_data.status = 2;
    },
    list_info (list, index) {
      if (this.lodg_data.status === 1 || this.lodg_data.status === 3) {
        this.$popup(CustomerEdit, null, {list: list, lodg_data: this.lodg_data, owner: this.owner, index: index, height: this.$root.$el.offsetHeight, cb: this.data_get});
      } else {
        this.$popup(CustomerInfo, null, {list: list, lodg_data: this.lodg_data, owner: this.owner, index: index, height: this.$root.$el.offsetHeight, type: 'user'});
      }
    },
    message_pop (type) {
      let ld = new this.$loader(this);
      ld._data_set({type});
      ld._post_cb_f = this.message_pop_cb;
      ld._load_start('user_mail_get.php');
    },
    message_pop_cb (res) {
      if (res.res === 1) {
        this.$popup(MailMessage, null, {mail: res.data.mail});
      }
    },
    get_qr (item) {
      // let ld = new this.$loader(this);
      // ld._data_set({customer_id: item.id});
      // ld._post_cb_f = this.get_qr_cb;
      // ld._load_start('qr_code_get.php');
      this.$router.push({ name: 'user_qr_reader', params: {} });
    },
    get_qr_cb (res) {
      if (res.res === 1) {
        this.$popup(GetQr, null, {qr_data: res.data.qr_code});
      }
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.user-list-info-box {
  text-align: left;

  .main-container {
    padding-bottom: 54px;
    .btn-box {
      width: calc(100% - 48px);
      position: fixed;
      bottom: 0px;
      display: flex;
      margin: 10px auto 0 auto;
      justify-content: center;
      // position: sticky;
      padding: 10px 0 10px 10px;
      // bottom: 0;
      background:#d7d7dae0;

      input {
        margin-right: 10px;
      }

      // z-index: 900;
    }
    .new-add {
      display: block;
      text-align: center;
      padding: 8px 8px 8px 8px;
      font-size: 16px;
      text-decoration: none;
      border-radius: 3px;
      width: 150px;
    }
    .btn-red {
      background: #ea6262;
      transition: all 0.2s ease;
    }
    .btn-red:hover {
      background: #ffa2a2;
    }

    .info-box {
      display: flex;

      .info-btn-box {
        margin-top: 24px;
        .message-btn {
          display: block;
          text-align: center;
          padding: 8px 8px 8px 8px;
          font-size: 16px;
          text-decoration: none;
          border-radius: 3px;
          margin-left: auto;
          margin-right: auto;
          margin-bottom: 16px;
          width: 200px;
        }
        .message-btn-s {
          font-size: 12px;
        }
      }
    }

    .lodg-info {
      width: 260px;
      padding: 10px;
      background: #fbfbfb;
      margin-right: 10px;
      border: 1px solid #d3d4d8;
    }

    .info-title {
      padding: 3px;
      color: #ff6e5a;
    }

    .info-item {
      padding: 3px 3px 3px 13px;
    }

    .list-box {
      overflow-y: auto;
      height: calc(100vh - 215px);
      flex: 1;
    }
    .list-header-box {
      position: sticky;
      top: 0;
      p {
        background: #fbfbfb;
        border-top: 1px solid #d3d4d8;
        border-left: 1px solid #d3d4d8;
        border-bottom: 1px solid #d3d4d8;
        padding: 10px;
        color: #24273b;

        text-align: center;
        box-sizing: border-box;
        height: 46px;
      }
      p:last-child {
        border-right: 1px solid #d3d4d8;
      }
    }
    .list-contents-box {
      div {
        border-bottom: 1px solid #d3d4d8;
        p {
          
          border-left: 1px solid #d3d4d8;
          padding: 8px;

          box-sizing: border-box;
          background: #fbfbfb;
        }
        p:last-child {
          border-right: 1px solid #d3d4d8;
        }
      }
    }
    .list-item1 {
      display: flex;
      font-size: 14px;
      justify-content: space-between;
      align-items: center;
      min-width: 300px;
      max-width: 300px;
      .qr-btn {
        display: block;
        text-align: center;
        padding: 2px 8px;
        font-size: 14px;
        text-decoration: none;
        border-radius: 3px;
      }
    }
    .list-item2 {
      min-width: 120px;
      flex: 1;
    }
    .list-item3 {
      min-width: 100px;
      max-width: 100px;
    }

  }
  .remand-box {
    border: 1px solid #d3d4d8;
    background: #fbfbfb;
    padding: 20px;
    margin: 0 0 20px 0;
  }
  .remand-date {
    background: #efefef;
    padding: 5px;
    margin: 10px 0 0 0;
  }
  .top-status-messege1 {
    display: none;
    padding-bottom: 8px;
  }
  .bottom-status-messege1 {
    padding: 8px 0;
  }
  .important_color {
    color: #e91e63 !important;
    font-size: 18px;
    font-weight: bold;
  }
  .important_background {
    width: 200px !important;
    background: #e91e63 !important;
  }
  @media (max-width: 767px) {
    .main-container {
      .btn-box {
        width: calc(100% - 31px);
      }
      .info-box {
        display: block;
      }

      .lodg-info {
        width: calc(100vw - 42px);
        margin-bottom: 10px;
      }
      .list-box {
        overflow-y: visible;
        height: auto;
        .list-header-box {
          .list-item1 {
            display: none;
          }
        }
        .list-contents-box {
          .flex {
            display: block;
          }
          .list-item1 {
            max-width: 100%;
            border-right: 1px solid #d3d4d8;
          }
        }
      }
      .top-status-messege1 {
        display: block;
      }
    }
  }
}
</style>
